export const scrollToElem = function (elemID, excludeHeader, speed, offset = 0) {

    var $elem = $(elemID),
        elemTop = $elem.offset().top,
        headerHeight = $('header').outerHeight();
    speed = typeof speed === 'undefined' ? 400 : speed;

    $("html, body").animate(
        { scrollTop: excludeHeader ? elemTop - headerHeight - offset : elemTop },
        speed
    );

}

export const scrollToHash = () => {
    let { hash } = window.location
    hash = hash.includes('?') ? hash.slice(0, hash.indexOf('?')) : hash
    const scrollTarget = `${hash}-scroll`

    if (document.querySelector(scrollTarget)) {
        scrollToElem(scrollTarget, true)
    }
}

document.addEventListener('DOMContentLoaded', function(){

    var $anchorCollapse = $('a[data-anchor="collapse"]');

    if( $anchorCollapse.length ) {

        $anchorCollapse.each( function( ) {
            var $this = $(this),
                thisHref = $this.attr('href'),
                $panel = $(thisHref),
                collapsePanelHref = $('[data-toggle="collapse"]', $panel).attr('href');

            $this.click(function() {
                $(collapsePanelHref).collapse('show');
                scrollToElem(thisHref);
            });

        });
    }

}, false);

export class ButtonAnchor {
    constructor({
                    selector = '',
                    target = '',
                    excludeHeader = false,
                    speed = 400,
                    offset = 0
                }) {
        this.items = document.querySelectorAll(selector)
        this.target = target
        this.targetEl = document.querySelector(target)
        this.excludeHeader = excludeHeader
        this.speed = speed
        this.offset = offset

        this.init()
    }
    init() {
        if (!this.targetEl) {
            console.error('TARGET DOM ELEMENT NOT FOUND!');
            return;
        }
        this.attachEvents()
    }
    attachEvents() {
        [...this.items].forEach(
            item => item.addEventListener('click', (e) => this.handleClick(e))
        )
    }
    handleClick(e) {
        try {
            e.preventDefault();
            return scrollToElem(this.target, this.excludeHeader, this.speed, this.offset);
        } catch (error) {
            console.error(error)
            return false;
        }
    }
}
